import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import CircularProgress from "@mui/material/CircularProgress";
import { useTheme } from "@mui/material/styles";
import { LoadingPlaceholderParent, LoadingPlaceholderText } from "./LoadingPlaceholder.styles";
import { useTranslation } from "react-i18next";
export const LoadingPlaceholder = (props) => {
    var _a, _b, _c;
    const { t } = useTranslation(["common"]);
    const theme = useTheme();
    return (_jsxs(LoadingPlaceholderParent, { ...props, children: [_jsx(CircularProgress, { className: "loadingButtonCircularProgress", size: (_a = props.size) !== null && _a !== void 0 ? _a : 48, sx: {
                    color: (_b = props.color) !== null && _b !== void 0 ? _b : theme.palette.primary.main,
                } }), _jsx(LoadingPlaceholderText, { children: (_c = props.text) !== null && _c !== void 0 ? _c : t("Loading...") })] }));
};
